import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  dialog: {
    borderRadius: theme.shape.borderRadius,
    backgroundColor: "#f8d7da",
    border: "1px solid #f5c6cb",
  },
  title: {
    color: "#721c24",
    fontWeight: "bold",
  },
  content: {
    color: "#721c24",
  },
  actions: {
    justifyContent: "center",
  },
  button: {
    backgroundColor: "#f5c6cb",
    color: "#721c24",
    "&:hover": {
      backgroundColor: "#f1b0b7",
    },
  },
}));

export default function ErrorDialog({ open, onClose, message }) {
  const classes = useStyles();

  return (
    <Dialog open={open} onClose={onClose} classes={{ paper: classes.dialog }}>
      <DialogTitle className={classes.title}>Error</DialogTitle>
      <DialogContent>
        <Typography className={classes.content}>{message}</Typography>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <Button onClick={onClose} className={classes.button}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}